module.exports = __webpack_public_path__ + "media/images/pc/stores/karuizawa/karuizawa_concept_04-02edd33f02d23d0d8c06fcd132f5439a.jpg";